/**
 * Handle blog page javascript behavior
 */

window.app = window.app || {};

(function (blogManager, $) {
    /**
     *
     * @type {string}
     * @private
     */
    var _maVar = "maVar";

    /**
     * Initializes the behavior.
     */
    blogManager.init = function () {
        _handleEvents();
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {
        $(document).ready(function(){
            $('.bxslider').bxSlider({
                controls: false,
                infiniteLoop: true,
                autoStart: true,
                auto: true
            });
        });
    };
})(
    window.app.blogManager = window.app.blogManager || {},
    jQuery
);
